<div class="col-6 row">
  <div class="col-4 details-key-main">
    <div class="col-12">
      {{field.label}}
    </div>
  </div>
  <div class="col-8">
    <div class="form-group col-12 paddingzero margin-bottom-0 row">
      <div class="col-12">
        <div class="col-12" style="margin: 10px 0px 10px 0;" [formGroup]="group">
          <mat-checkbox [formControlName]="field.name">{{field.label}}</mat-checkbox>
        </div>
      </div>
    </div>
  </div>
</div>
